import type { QuerySanitizer } from './types';
import { marketsValidator, regionsValidator, segmentsValidator } from './sanitize';

export const emValidators: Record<string, QuerySanitizer> = {
  markets: marketsValidator,
  regions: regionsValidator,
  segments: segmentsValidator,
};
